import { StateValue } from 'xstate';

import { ProductBuilderMachineState } from '../types';

type GetStateKey = (currentState: StateValue) => ProductBuilderMachineState;

export const getStateKey: GetStateKey = currentState => {
  if (typeof currentState === 'string')
    return currentState as ProductBuilderMachineState;
  return Object.keys(currentState)[0] as ProductBuilderMachineState;
};
